/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/utils/request';
// 获取我的处理工单列表
// export function handleActionList(param, url = '/workOrder/index/handleActionList') {
//   return request({
//     url: url,
//     method: 'post',
//     data: param
//   })
// }
export var handleActionList = function handleActionList(param) {
  return request({
    url: '/workOrder/index/handleActionList',
    method: 'post',
    data: param
  });
};
export var actionHandle = function actionHandle(param) {
  return request({
    url: '/workOrder/index/actionHandle',
    method: 'post',
    data: param
  });
};